// extracted by mini-css-extract-plugin
export var container = "_tx-0";
export var table = "_tx-2";
export var tableWrapper = "_tx-1";